module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_23-219964a1e6736e1964ac7c6e1aa403d7.jpg";